import { apiClient } from './ApiClient'
import { Attachment, AttachmentSummary } from '../types/entities'

export interface UploadAttachmentResponse {
  attachmentId: string
  fileName: string
  originalFileName: string
  fileSize: number
  contentType: string
  downloadUrl: string
  isImage: boolean
}

export class AttachmentService {
  private basePath = '/attachments'

  async uploadAttachment(
    file: File,
    ticketId?: string,
    messageId?: string
  ): Promise<UploadAttachmentResponse> {
    const formData = new FormData()
    formData.append('File', file)
    if (ticketId) formData.append('TicketId', ticketId)
    if (messageId) formData.append('MessageId', messageId)

    return apiClient.postFormData<UploadAttachmentResponse>(this.basePath, formData)
  }

  async getTicketAttachments(ticketId: string): Promise<AttachmentSummary[]> {
    return apiClient.get<AttachmentSummary[]>(`${this.basePath}/ticket/${ticketId}`)
  }

  async getAttachment(attachmentId: string): Promise<Attachment> {
    return apiClient.get<Attachment>(`${this.basePath}/${attachmentId}`)
  }

  async deleteAttachment(attachmentId: string): Promise<void> {
    return apiClient.delete(`${this.basePath}/${attachmentId}`)
  }

  getDownloadUrl(attachmentId: string): string {
    const baseUrl = import.meta.env.VITE_API_URL || 'http://localhost:5010'
    return `${baseUrl}/api/attachments/${attachmentId}/download`
  }
}

export const attachmentService = new AttachmentService()
